import { z } from "zod"

export const numberStringSchema = z
  .string()
  .trim()
  .min(1)
  .refine((value) => !Number.isNaN(Number(value)), {
    message: "Must be a valid number",
  })

export const optionalNumberStringSchema = z
  .string()
  .trim()
  .refine((value) => value === "" || !Number.isNaN(Number(value)), {
    message: "Must be a valid number",
  })
  .default("")
